export const API = process.env.REACT_APP_API_URL;
export const KEYID = process.env.REACT_APP_RAZORPAY_KEY_ID;
export const SECRETEKEY = process.env.REACT_APP_RAZORPAY_KEY_SECRET;
export const THEME_COLOR = "#1a3c8b";